import { Theme, useMediaQuery } from '@mui/material';
import { getBGImage } from 'constants/images';
import SEARCH_PARAMS from 'constants/searchParams';
import { VendorsByCategories } from 'pages/VendorsByCategories/VendorsByCategories';
import { useQuery } from 'react-query';
import { Route, Routes, useLocation, useSearchParams } from 'react-router-dom';
import { Spacer } from '../../components/atoms';
import { Footer, FrontSideNav } from '../../components/molecules';
import { getAllCategories } from '../../network/services/goods';
import { GoodsBySearch } from '../../pages';
import { ProductsBySubCategory } from '../../pages/Products';
import { CATEGORIES, SEARCH } from '../routes';
import { CategoriesGridCon, CategoriesLeft, Right } from '../styles';

const CategoriesRoutes = () => {
  const md = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [searchParam] = useSearchParams();
  const vendorParam = searchParam.get(SEARCH_PARAMS.VENDOR_ID);
  const bgId = searchParam.get(SEARCH_PARAMS.BG_ID);
  const profileImage = searchParam.get(SEARCH_PARAMS.PROFILE_IMAGE);
  const vendorId = vendorParam ? parseInt(vendorParam) : undefined;

  const category = searchParam.get('category');
  const vendor = searchParam.get('vendor');
  const { pathname } = useLocation();
  const isSearchPage = pathname.endsWith(SEARCH);
  const pathSegments = pathname.split('/').filter(segment => segment !== '');
  const isSubCategoryPage = pathSegments.length >= 3 && pathSegments[0] === 'categories';
  const needsCategoryNav = !isSearchPage && !(vendor && category) && !isSubCategoryPage;

  const { data, isLoading } = useQuery({
    queryKey: ['categories', vendorId],
    queryFn: () => getAllCategories(vendorId),
    enabled: needsCategoryNav,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    retry: 1,
    retryDelay: 1000
  });

  const categories = data
    ? data?.map(c => ({
        to: {
          pathname: `${CATEGORIES}/${c.name.replace(/\s/g, '-')}`.toLowerCase(),
          search: `category=${c.id}${vendorId ? `&vendorId=${vendorId}` : ''}`
        },
        name: c.name,
        id: c.id,
        logo: c.logo
      }))
    : [];

  return (
    <>
      {vendorId && bgId && (
        <div className="relative w-screen h-fit">
          <img
            src={getBGImage(Number(bgId))}
            alt="vendor-logo"
            className="w-screen max-h-[200px] md:max-h-[457px] object-cover"
          />
          <div className="h-full w-full absolute top-0 bg-black/60" />
          <img
            className="absolute z-[1] left-5 shadow -bottom-10 w-16 h-16 rounded bg-[#E7E6E6]"
            src={profileImage && profileImage !== '' ? decodeURIComponent(profileImage) : '/graphics/madina.svg'}
            alt="vendor-profile"
          />
        </div>
      )}

      <CategoriesGridCon>
        {!isSearchPage && !(vendor && category) && !isSubCategoryPage && (
          <CategoriesLeft>
            <FrontSideNav isLoading={isLoading} title="Categories" navs={categories} />
          </CategoriesLeft>
        )}
        <Right>
          <Routes>
            <Route path={SEARCH} element={<GoodsBySearch />} />
            <Route path={`:category`} element={<VendorsByCategories />} />
            <Route path={`:category/:vendor/:sub_category`} element={<ProductsBySubCategory />} />
          </Routes>
        </Right>
      </CategoriesGridCon>

      <Spacer height={md ? 20 : 80} />

      <Footer />
    </>
  );
};

export default CategoriesRoutes;
